<template>
  <div>
    <Header />
<!--    <Breadcrumbs :title="getProductDetail.productName" />-->
    <section class="section-b-space pt-0 shop_content">
      <div class="collection-wrapper">
        <div class="container">
          <div class="row">
            <div class="col-lg-3">
            </div>
            <div class="col-lg-9 col-sm-12 col-xs-12 productdetail">
              <div class="container-fluid">
                <router-link :to="{ path: '/shop' }" class="cart-go-shop"><i class="fa fa-arrow-left"></i></router-link>
                <div class="row">
                  <div class="col-lg-6">
                    <div v-swiper:mySwiper="swiperOption" ref="mySwiper">
                      <div class="swiper-wrapper">
                        <div
                          class="swiper-slide"
                          v-for="(product,index) in [1,2,3]"
                          :key="index"
                        >
                          <div class="cart-count" v-if="getQtyInCart() > 0">
                            {{getQtyInCart()}}
                          </div>
                          <img
                              :src='require("@/assets/images/ajax-loader.gif")'
                              class="img-fluid bg-img loading-img"
                            />
                          <img
                            :src="getProductDetail.productPictureURL"
                            :id="index"
                            class="img-fluid bg-img product-img"
                            :alt="`product${index}`"
                          />
                        </div>
                      </div>
                    </div>
<!--                    <div class="row">-->
<!--                      <div class="col-12 slider-nav-images">-->
<!--                        <div v-swiper:mySwiper1="swiperOption1">-->
<!--                          <div class="swiper-wrapper">-->
<!--                            <div-->
<!--                              class="swiper-slide"-->
<!--                              v-for="(product,index) in [1,2,3]"-->
<!--                              :key="index"-->
<!--                            >-->
<!--                               <img-->
<!--                                    :src='require("@/assets/images/ajax-loader.gif")'-->
<!--                                    class="img-fluid bg-img w-100"-->
<!--                                  />-->
<!--                                <img-->
<!--                                  :src="getProductDetail.productPictureURL"-->
<!--                                  :id="index"-->
<!--                                  class="img-fluid bg-img r-img"-->
<!--                                  :alt="`product${index}`"-->
<!--                                />-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
                  </div>
                  <div class="col-lg-6 rtl-text">
                    <div class="product-right">

                      <template v-if="getProductDetail.is_sale_item === 1 && getProductDetail.is_new_item === 0">
                        <h2 style="color: red">SALE</h2>
                      </template>
                      <template v-if="getProductDetail.is_sale_item === 1 && getProductDetail.is_new_item === 1">
                        <h2 style="color: red">NEW  SALE</h2>
                      </template>
                      <template v-if="getProductDetail.is_sale_item === 0 && getProductDetail.is_new_item === 1">
                        <h2 style="color: red">NEW</h2>
                      </template>


                      <h2>{{ getProductDetail.productName }}</h2>
                      <h4 v-if="getProductDetail.sale">
                        <del>{{ getProductDetail.priceInMinorUnits * currency.curr | currency(currency.symbol) }}</del>
                        <span>{{ getProductDetail.discount }}% off</span>
                      </h4>
                      <h3 v-if="getProductDetail.sale">{{ discountedPrice(getProductDetail) * currency.curr | currency(currency.symbol) }}</h3>
                      <h3 v-else>{{ getProductDetail.priceInMinorUnits * currency.curr | currency(currency.symbol) }}</h3>


                      <div class="product-description border-product">
                        <!-- <h6 class="product-title">quantity</h6> -->
                        <!--
                        <div class="qty-box">
                          <div class="input-group">
                            <span class="input-group-prepend">
                              <button
                                type="button"
                                class="btn quantity-left-minus"
                                data-type="minus"
                                data-field
                                v-on:click="decrement()"
                              >
                                <i class="ti-minus"></i>
                              </button>
                            </span>
                            <input
                              type="number"
                              name="quantity"
                              class="form-control input-number"
                              v-model="counter"
                            />
                            <span class="input-group-prepend">
                              <button
                                type="button"
                                class="btn quantity-right-plus"
                                data-type="plus"
                                data-field
                                v-on:click="increment()"
                              >
                                <i class="ti-plus"></i>
                              </button>
                            </span>
                          </div>
                        </div>
                        -->
                        <div class="product-buttons">
                          <button
                            class="btn btn btn-solid checkout-btn add-to-cart-btn"
                            title="Add to cart"
                            @click="addToCart(getProductDetail, counter)"
                          >Add to Cart</button>
                        </div>
                      </div>

                      <div class="border-product">
                        <p></p>
                        {{getProductDetail.thc_line}}
                        <p>{{getProductDetail.full_description&&getProductDetail.full_description}}</p>
                        <p></p>
                        <p></p>
<!--                        <br>-->
<!--                        <p>SKU: {{getProductDetail.sku}}</p>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>

<!--              <section class="tab-product m-0">-->
<!--                <div class="row">-->
<!--                  <div class="col-sm-12 col-lg-12">-->
<!--                    <b-tabs card>-->
<!--                      <b-tab title="Description" active>-->
<!--                        <b-card-text>{{getProductDetail.full_description}}</b-card-text>-->
<!--                      </b-tab>-->
<!--                      <b-tab title="Details">-->
<!--                        <b-card-text>-->
<!--                          {{getProductDetail.productDescription}}-->
<!--                          <div class="single-product-tables">-->
<!--                          </div>-->
<!--                        </b-card-text>-->
<!--                      </b-tab>-->
<!--                    </b-tabs>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </section>-->


            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import Header from '@/components/header'
import Footer from '@/components/footer'

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      counter: 1,
      activeColor: '',
      selectedSize: '',
      size: [],
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 20,
        freeMode: true
      },
      swiperOption1: {
        slidesPerView: 3,
        spaceBetween: 30,
        freeMode: true,
        centeredSlides: false
      }
    }
  },
  computed: {
    ...mapState({
      currency: state => state.products.currency
    }),
    ...mapGetters({
      curr: 'products/changeCurrency',
      getLoaded: 'products/getLoaded',
      cartItems: 'cart/cartItems',
    }),
    getProductDetail: function () {
      return this.$store.getters['products/getProductById'](
        this.$route.params.id
      )
    },
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted() {
    this.activeColor = this.uniqColor
    // alert(this.$route.params.id)
  },
  created() {
    if(!this.getLoaded) {
      this.$router.push({name: 'home'})
    }
  },
  methods: {
    getQtyInCart() {
      var qty_in_cart = 0;
      for(var i = 0; i < this.cartItems.length; i++) {
        if(this.cartItems[i].sku === this.getProductDetail.sku) {
          qty_in_cart = this.cartItems[i].qty;
        }
      }
      return qty_in_cart;
    },
    priceCurrency: function () {
      this.$store.dispatch('products/changeCurrency')
    },
    discountedPrice(product) {
      const price = product.price - (product.price * product.discount / 100)
      return price
    },
    Color(variants) {
      const uniqColor = []
      for (let i = 0; i < Object.keys(variants).length; i++) {
        if (uniqColor.indexOf(variants[i].color) === -1) {
          uniqColor.push(variants[i].color)
        }
      }
      return uniqColor
    },
    addToCart: function (product, qty) {
      var qtyint = parseInt(qty);
      this.$store.dispatch('cart/addToCart', {product,qtyint});
    },
    // Change size variant
    changeSizeVariant(variant) {
      this.selectedSize = variant
    },
    slideTo(id) {
      this.swiper.slideTo(id, 1000, false)
    },
    sizeVariant(id, slideId, color) {
      this.swiper.slideTo(slideId, 1000, false)
      this.size = []
      this.activeColor = color
      this.getProductDetail.variants.filter((item) => {
        if (id === item.image_id) {
          this.size.push(item.size)
        }
      })
    },
    // increment() {
    //   this.counter = parseInt(this.counter) + 1;
    // },
    // decrement() {
    //   this.counter = this.counter > 1 ? this.counter - 1 : 1;
    // },
  }
}
</script>
